/** The Feeds list's client-side matching over the `GET /mls` snapshot (the endpoint's `q` is a Mongo query, not a search box). */

type FeedRow = Record<string, unknown>;
type Target = { key?: unknown } | undefined;

/** Every field that has chosen values must hold one of them (case-insensitive); a `'all'` choice or none means no filter. */
export function matchesFeedFilters(row: FeedRow, chosen: Record<string, string[]>): boolean {
  return Object.entries(chosen).every(([field, values]) => {
    const wanted = values.map((value) => value.toLowerCase());
    if (!wanted.length || wanted.includes('all')) return true;
    return wanted.includes((row[field] as string | undefined)?.toString().toLowerCase() as string);
  });
}

/** True when the lower-cased `needle` is in the feed's id, name, bay keys, download times or servers. */
export function matchesFeedSearch(row: FeedRow, needle: string): boolean {
  const targets = row.targets as Record<string, Target> | undefined;
  const text = (value: unknown) => (value === undefined || value === null ? '' : String(value));
  return [
    row._id,
    row.name,
    targets?.ClientBAY?.key,
    targets?.SocialBAY?.key,
    row.dtLastDownload,
    row.dtLastDownloadFull,
    row.dataServer,
    row.dmServer,
  ].some((value) => text(value).toLowerCase().includes(needle.toLowerCase()));
}
